import { useQuery } from '@tanstack/react-query';
import { createLoyaltyQuery } from '~/services/loyalty/lib';
import { QueryKeys } from '~/services/loyalty/constants';
import { useLoyaltyContext } from '..';
import type { AllowedOptions } from '../allowedQueryOptions';
import type { LoyaltyApiError, PurchaseHistoryResponse } from '~/lib/data-contract/loyalty';

export const usePurchaseHistory = <TData = PurchaseHistoryResponse>(
    options?: AllowedOptions<PurchaseHistoryResponse, TData>,
) => {
    const { businessCentralId, translate, trackError } = useLoyaltyContext();

    return useQuery<PurchaseHistoryResponse, LoyaltyApiError, TData>({
        queryKey: [QueryKeys.PURCHASE_HISTORY],
        queryFn: createLoyaltyQuery('GetPurchaseHistory', translate, trackError, {
            sellToContactNo: businessCentralId,
        }),
        enabled: false,
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 1000 * 30,
        ...options,
    });
};
